// ONE skeleton kit (Founder 30/09/26: "placeholders with a light loading animation, then the details when the data arrives").
// Used ONLY where data genuinely arrives in the browser after load (a typed home search, lazy review pages) — a server-rendered
// list never shows one. Each placeholder has the real card's box (same padding/radius/border, fixed height) so the swap-in never
// shifts the layout; the shimmer is a soft left-to-right sheen and stops under prefers-reduced-motion.
import type { CSSProperties } from 'react';

const SHIMMER_CSS = `
@keyframes xsShimmer { from { background-position: 100% 0; } to { background-position: -100% 0; } }
.xs-bone { background: linear-gradient(90deg, #eef2f7 0%, #f6f8fb 40%, #eef2f7 80%); background-size: 200% 100%; animation: xsShimmer 1.3s ease-in-out infinite; border-radius: 6px; }
@media (prefers-reduced-motion: reduce) { .xs-bone { animation: none; } }
`;
export function SkeletonStyles() { return <style>{SHIMMER_CSS}</style>; }

const Bone = ({ style }: { style: CSSProperties }) => <div className="xs-bone" aria-hidden style={style} />;

/** Review card placeholder — the same box as ReviewsList's ReviewCard (width = the strip's column width). */
export function ReviewCardSkeleton({ width = 210 }: { width?: number }) {
  return (
    <div aria-hidden className="flex-shrink-0 rounded-xl" style={{ width, padding: 10, background: '#f8fafc', border: '1px solid #eef2f7' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 7 }}>
        <Bone style={{ width: 26, height: 26, borderRadius: '50%', flexShrink: 0 }} />
        <Bone style={{ width: 80, height: 11 }} />
      </div>
      <Bone style={{ height: 11, marginBottom: 5 }} />
      <Bone style={{ height: 11, width: '70%' }} />
    </div>
  );
}

/** Pro card placeholder — the homepage expert card (components/HomeExperts ProCard): face + five text rows, a reviews strip,
 *  the "view profile" row. Fixed height = the real card's measured height (376–383px at 390 and 1280). */
export function ProCardSkeleton({ height = 380 }: { height?: number }) {
  return (
    <div aria-hidden style={{ height, background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(0,0,0,.08)', border: '1.5px solid #e8edf5', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      <div style={{ padding: '16px 16px 12px', display: 'flex', alignItems: 'center', gap: 12 }}>
        <Bone style={{ width: 96, height: 96, borderRadius: '50%', flexShrink: 0 }} />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
          <Bone style={{ height: 16, width: '55%' }} />
          <Bone style={{ height: 11, width: '40%' }} />
          <Bone style={{ height: 11, width: '32%' }} />
          <Bone style={{ height: 12, width: '48%' }} />
          <Bone style={{ height: 10, width: '28%' }} />
        </div>
      </div>
      <div style={{ borderTop: '1px solid #f1f5f9', margin: '0 16px' }} />
      <div style={{ padding: '10px 16px 14px', display: 'flex', gap: 10, flex: 1, overflow: 'hidden' }}>
        <ReviewCardSkeleton /><ReviewCardSkeleton />
      </div>
      <div style={{ borderTop: '1px solid #f1f5f9', padding: '12px 16px', display: 'flex', justifyContent: 'center' }}>
        <Bone style={{ height: 12, width: 90 }} />
      </div>
    </div>
  );
}
